export enum FilterButtonTypesEnum {
  list = 'list',
  multiList = 'multi',
  date = 'date',
  monthYear = 'monthYear',
}
